import { BASE_API } from "../utils/constants";


export async function editBusinessHourApi (id, data, token)  {

    try {
        
        const url = `${BASE_API}/api/business-hours/${id}/`;
        const params = {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${token}`, 
                "Content-type": "application/json"            
            },
            body: JSON.stringify(data) 
        }

        const response = await fetch(url, params);
        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }


}


